export default __webpack_public_path__ + "static/media/arrow-right.3694f1a5.svg";